import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const formatReportData = (data, index) => ({
  'S.NO.': data.row_number || index + 1,
  'REPORT ID': data.report_id,
  'SAMPLE ID': (data.sample_id || '').toUpperCase(),
  'FARM NAME': (data.farm_name || '').toUpperCase(),
  'FARM SIZE': `${(data.farm_size || '').toUpperCase()} ${(data.farm_size_unit || '').toUpperCase()}`,
  'LOCATION': (data.city || '').toUpperCase(),
  'PREVIOUS CROP': (data.previous_crop || '').toUpperCase(),
  'NEXT CROP': (data.next_crop || '').toUpperCase(),
  'DATE': data.created_at ? new Date(Date.parse(data.created_at)).toDateString() : '',
  'LOCKED': data.is_locked ? 'Yes' : 'No'
});

export const exportToCSV = async (data) => {
  const csvData = data.map((record, i) => formatReportData(record, i));
  const csv = Papa.unparse(csvData);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  try {
    const link = document.createElement('a');
    link.href = url;
    link.download = 'reports_export.csv';
    document.body.appendChild(link);
    link.click();
  } finally {
    URL.revokeObjectURL(url);
  }
};

export const exportToExcel = async (data) => {
  const worksheetData = data.map((record, i) => formatReportData(record, i));
  const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Reports');
  XLSX.writeFile(workbook, 'reports_export.xlsx');
};

export const exportToPDF = async (data) => {
  const doc = new jsPDF();
  doc.setFontSize(18);
  doc.text('Reports Export', 14, 22);

  const tableData = data.map((record, i) => [
    record.row_number || i + 1,
    record.report_id,
    (record.sample_id || '').toUpperCase(),
    (record.farm_name || '').toUpperCase(),
    `${(record.farm_size || '').toUpperCase()} ${(record.farm_size_unit || '').toUpperCase()}`,
    (record.city || '').toUpperCase(),
    (record.previous_crop || '').toUpperCase(),
    (record.next_crop || '').toUpperCase(),
    record.created_at ? new Date(Date.parse(record.created_at)).toDateString() : '',
    record.is_locked ? 'Yes' : 'No'
  ]);

  autoTable(doc, {
    startY: 30,
    head: [['S.NO.', 'REPORT ID', 'SAMPLE ID', 'FARM NAME', 'FARM SIZE', 'LOCATION', 'PREVIOUS CROP', 'NEXT CROP', 'DATE', 'LOCKED']],
    body: tableData
  });

  doc.save('reports_export.pdf');
};
